<template>
  <div style="height: 100%">
    <cTable
      ref="table"
      :fields="fields"
      :config="config"
      :modals="modals"
      :header="header"
      :methods="methods"
    >
      <template #header>
        <Tabs type="card" v-model="tabName" @on-click="handleTab">
          <TabPane
            v-for="(item, idx) in tabList"
            :key="idx"
            :label="item.label"
            :name="item.value"
          />
        </Tabs>
      </template>
    </cTable>
    <print ref="print" :printData="printData"></print>
  </div>
</template>

<script>
import { getAirLabel, uploadAirLabel, delAirLabel } from "@/api/tracker/air";
import UploadFile from "@/base/upload_file";
import print from "./print.vue";
import cTable from "@/base/common/index";
export default {
  name: "airPackingList",
  components: {
    cTable,
    UploadFile,
    print,
  },
  async mounted() {},
  methods: {
    handleTab(tab) {
      this.tabName = tab;
      this.config["showOverflow"] = tab === "2" ? false : true;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    },
    printFun(obj) {
      this.printData = obj;
    },
  },
  data() {
    let that = this;
    return {
      printData: [],
      tabList: [
        {
          label: this.$t("singleProduct"),
          value: "1",
        },
        {
          label: this.$t("multiProduct"),
          value: "2",
        },
      ],
      tabName: "1",
      methods: {
        list: (p) => {
          p.type = this.tabName;
          return getAirLabel(p);
        },
        uploadAirLabel,
        print: (obj) => {
          this.printFun(obj);
        },
        delAirLabel,
      },
      config: {
        showOverflow: true,
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "transport_type",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("method") +
                this.$t("country_code_type")
              );
            },
            component: "Select",
            options: [
              {
                label: this.$t("sea_transport"),
                value: "1",
              },
              {
                label: this.$t("air_transport"),
                value: "2",
              },
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export"),
            //   type: "export",
            //   fnName: "exportFun",
            //   bind: {
            //     icon: "md-arrow-down",
            //     type: "success"
            //   }
            //   // disabled() {
            //   //   return !this.selectAll.length;
            //   // }
            // },
            {
              name: () => this.$t("updateFile") + this.$t("airShippingMark"),
              // "(" +
              // (this.tabName == "1"
              //   ? this.$t("singleProduct")
              //   : this.$t("multiProduct")) +
              // ")",
              fnName: "updateFile",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("selectPrint") + this.$t("airShippingMark"),
              type: "print",
              fnName: "printFun",
              component: "Button",
              bind: {
                icon: "ios-print",
                type: "success",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$t("batch") + this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              component: "Button",
              bind: {
                icon: "ios-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            updateFile({ file, searchForm, field }) {
							if(file.size / 1024 / 1024 > 30)return this.$Message.error({
								content:this.$t('file30M'),
								background:true
							})
              let formData = new FormData();
              formData.append("file", file);
              // formData.append("type", that.tabName);
              this.$page
                .handleRequestMethods("uploadAirLabel", formData, true, true)
                .then((res) => {
                  // this.$page.handleMethods("print", res.payload);
                  this.$page.getList();
                });
              return false;
            },
            printFun() {
              this.handleMethods("print", this.selectAll);
            },
            deleteFun() {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("batch") +
                  this.$t("delete") +
                  this.$t("airShippingMark") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "delAirLabel",
                    { ids: this.selectAll.map((it) => it.id) },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
            exportFun({ field, searchForm }) {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
          show: false,
        },
        {
          name: () => this.$t("submitUser"),
          key: "submitter",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("inbound_time"),
          key: "outbound_time",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("shipment_place"),
          key: "outbound_address",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("b2bClient"),
          key: "customer",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Odd_Numbers"),
          key: "warehouse_no",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$t("sys") + this.$t("Odd_Numbers"),
          key: "airway_number",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$t("outerBoxNumber"),
          key: "box_no",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("inspectionPhoto"),
          key: "verify_img",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("inspectionPhoto"),
          key: "verify_img",
          align: "center",
          minWidth: 100,
          type: "child",
          rewriteKey: "verify_img_t",
          child: { list: "child" },
          show: () => this.tabName == "2",
        },
        {
          name: () => this.$t("original_packing_num"),
          key: "old_box_no",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("original_packing_num"),
          key: "old_box_no",
          align: "center",
          minWidth: 100,
          rewriteKey: "old_box_no_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
        },
        {
          name: () => this.$t("operation") + this.$t("order_desc"),
          key: "remarks",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("operation") + this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100,
          rewriteKey: "remarks_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
        },
        {
          name: () => this.$t("clearance_time") + this.$t("productName"),
          key: "clearance_name",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "1",
        },
        {
          name: () => this.$t("clearance_time") + this.$t("productName"),
          key: "clearance_name",
          align: "center",
          minWidth: 100,
          rewriteKey: "clearance_name_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
        },
        {
          name: () => this.$t("productName") + this.$t("En"),
          key: "en_name",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "1",
        },
        {
          name: () => this.$t("productName") + this.$t("En"),
          key: "en_name",
          rewriteKey: "en_name_t",
          type: "child",
          child: { list: "child" },
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "2",
        },
        {
          name: () => this.$t("productName") + this.$t("Zh"),
          key: "cn_name",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "1",
        },
        {
          name: () => this.$t("productName") + this.$t("Zh"),
          key: "cn_name",
          rewriteKey: "cn_name_t",
          type: "child",
          child: { list: "child" },
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "2",
        },
        {
          name: () => "HS",
          key: "hs_code",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => "HS",
          key: "hs_code",
          rewriteKey: "hs_code_t",
          align: "center",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("model"),
          key: "model_no",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("model"),
          key: "model_no",
          rewriteKey: "model_no_t",
          align: "center",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("trademark"),
          key: "trademark",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("trademark"),
          key: "trademark",
          rewriteKey: "trademark_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("barcode_t"),
          key: "barcode",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("case_number"),
          key: "box_num",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("pretendNumber"),
          key: "box_num",
          rewriteKey: "box_num_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("number_of_bags"),
          key: "number",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("totalNumber"),
          key: "total_num",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 120,
        },
        {
          name: () => this.$t("totalNumber"),
          key: "total_num",
          rewriteKey: "total_num_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("unit_t"),
          key: "unit",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("unit_t"),
          key: "unit",
          align: "center",
          rewriteKey: "unit_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("length"),
          key: "length",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("width"),
          key: "width",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("height"),
          key: "height",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_volume"),
          key: "weight_volume",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("doublePrice") + "($)",
          key: "price",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("doublePrice") + "($)",
          key: "price",
          align: "center",
          rewriteKey: "price_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("has_trademark"),
          key: "brand",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("has_trademark"),
          key: "brand",
          align: "center",
          rewriteKey: "brand_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("has_electric"),
          key: "charged",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "1",
        },
        {
          name: () => this.$t("has_electric"),
          key: "charged",
          align: "center",
          rewriteKey: "charged_t",
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("whether") + this.$t("magnetic"),
          key: "magnetic",
          align: "center",
          show: () => this.tabName == "1",
          minWidth: 100,
        },
        {
          name: () => this.$t("whether") + this.$t("magnetic"),
          key: "magnetic",
          align: "center",
          type: "child",
          rewriteKey: "magnetic_t",
          child: { list: "child" },
          show: () => this.tabName == "2",
          minWidth: 100,
        },
        {
          name: () => this.$t("has_tableware"),
          key: "tableware",
          align: "center",
          minWidth: 100,
        },
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("delete"),
        //       type: "delete",
        //       fnName: "deleteFun",
        //       bind: {
        //         type: "error",
        //       },
        //     },
        //   ],
        //   methods: {
        //     deleteFun({ row }) {
        //       this.$Modal.confirm({
        //         title:
        //           this.$t("whether") +
        //           this.$t("confirm") +
        //           this.$t("delete") +
        //           this.$t("airShippingMark") +
        //           "?",
        //         onOk: () => {
        //           this.handleRequestMethods("delAirLabel", row.id, true).then(
        //             (res) => {
        //               // this.$Message.success(res.data.msg);
        //               this.getList();
        //             }
        //           );
        //         },
        //       });
        //     },
        //   },
        // },
      ],
    };
  },
};
</script>
<style type="text/css"></style>
<style lang="scss" scoped></style>
